import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './LoginRoute.css';
// import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { getVerCodeApi, loginApi } from './api';
import { servicesManager } from '../App.js';
import { user } from '@ohif/core';

// Contexts
import AppContext from '../context/AppContext';
import { api } from 'dicomweb-client';

function LoginRoute(props) {
  const { history, server } = props;
  //form表单
  const [verCode, setVerCode] = useState();
  const [isGetVerCode, setIsGetVerCode] = useState(1);
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [errors, setErrors] = useState({
    phone: null,
    password: null,
    code: null,
  });
  const appContext = useContext(AppContext);

  // Google Cloud Adapter for DICOM Store Picking
  const { appConfig = {} } = appContext;

  // Called when relevant state/props are updated
  // Watches filters and sort, debounced
  useEffect(
    () => {
      const getVerCode = async () => {
        try {
          const response = await getVerCodeApi();
          if (response) {
            createImageFromBlob(response.data);
          }
        } catch (error) {
          console.warn(error);
        }
      };

      if (server) {
        getVerCode();
      }
    },
    // TODO: Can we update studies directly?
    // eslint-disable-next-line react-hooks/exhaustive-dep
    [appConfig, isGetVerCode, server]
  );

  // this.createImageFromBlob(res);

  function createImageFromBlob(image) {
    let reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        setVerCode(reader.result);
        // this.verCode = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result);
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  function handleValueChange(field, value, type = 'string') {
    if (type === 'number') {
      value = +value;
    }
    switch (field) {
      case 'phone': {
        var regex = /^((\+)?86|((\+)?86)?)0?1[3456789]\d{9}$/;
        if (value.toString().length < 11) {
          setErrors(prevState => {
            return { ...prevState, phone: '手机号不得小于11位字符' };
          });
        } else if (value.toString().length > 11) {
          setErrors(prevState => {
            return { ...prevState, phone: '手机号不得大于11位字符' };
          });
        } else if (value.toString().length === 0) {
          setErrors(prevState => {
            return { ...prevState, phone: '请输入手机号' };
          });
        } else {
          if (regex.test(value)) {
            setErrors(prevState => {
              return { ...prevState, phone: null };
            });
          } else {
            setErrors(prevState => {
              return { ...prevState, phone: '手机号格式错误' };
            });
          }
        }
        setPhone(value);
        break;
      }
      case 'password': {
        if (value.length < 3) {
          setErrors(prevState => {
            return { ...prevState, password: '密码不得小于3位字符' };
          });
        } else if (value.length === 0) {
          setErrors(prevState => {
            return { ...prevState, password: '请输入密码' };
          });
        } else {
          setErrors(prevState => {
            return { ...prevState, password: null };
          });
        }
        setPassword(value);
        break;
      }
      case 'code': {
        if (value.length == 4) {
          setErrors(prevState => {
            return { ...prevState, code: null };
          });
        } else {
          setErrors(prevState => {
            return { ...prevState, code: '验证码为4位数' };
          });
        }
        setCode(value);
        break;
      }
      default: {
        //
      }
    }

    // this.setState({
    //     form: {
    //         ...form,
    //         [field]: newFieldObj
    //     }
    // });
  }

  const handleSubmit = async e => {
    // let ssion = sessionStorage.getItem('session_id_');
    // console.log(ssion);
    e.preventDefault();
    if (!errors.phone && !errors.password && !errors.code) {
      // user.userLoggedIn = () => true;
      // user.getAccessToken = () => 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50SWQiOjY1LCJ1c2VyTmFtZSI6IuW9seaguFlBSkU5In0.aP8KXipKbcx48eiZqSpLqZy4w8Fiz4WHLxMieJdkZ-k';
      // user.getName = () => 'yinghe';
      // let obj = {
      //     userName: 'yinghe',
      //     avatar: '',
      //     // token: res.data.token,
      //     token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50SWQiOjY1LCJ1c2VyTmFtZSI6IuW9seaguFlBSkU5In0.aP8KXipKbcx48eiZqSpLqZy4w8Fiz4WHLxMieJdkZ-k',
      // };
      // localStorage.setItem('user', JSON.stringify(obj));
      // history.push('/studylist')

      let payload = {
        phone: phone,
        password: password,
        veryCode: code,
      };
      const { UINotificationService } = servicesManager.services;
      loginApi(payload).then(res => {
        if (res.status === 'success') {
          if (res.data.passwordExpired === '00') {
            UINotificationService.hideAll();
            const message = '';
            UINotificationService.show({
              title: '登录成功',
              message,
              type: 'info',
              autoClose: true,
            });
            user.userLoggedIn = () => true;
            user.getAccessToken = () => res.data.token;
            user.getName = () => res.data.userName;
            let obj = {
              userName: res.data.userName,
              avatar: res.data.avatar,
              token: res.data.token,
            };
            localStorage.setItem('user', JSON.stringify(obj));
            history.push('/studylist');
          } else if (res.data.passwordExpired === '05') {
            const msg = (
              <div
                id="testHide"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div>您的密码即将过期，请及时前往影禾云平台修改!</div>
                <a href={appConfig.url} target="_blank" rel="noreferrer">
                  立刻前往
                </a>
              </div>
            );
            UINotificationService.show({
              title: '系统提醒',
              id: 'testHide',
              message: msg,
              type: 'info',
              duration: 6000,
              autoClose: true,
            });
            user.userLoggedIn = () => true;
            user.getAccessToken = () => res.data.token;
            user.getName = () => res.data.userName;
            let obj = {
              userName: res.data.userName,
              avatar: res.data.avatar,
              token: res.data.token,
            };
            localStorage.setItem('user', JSON.stringify(obj));
            history.push('/studylist');
          } else if (res.data.passwordExpired === '10') {
            const msg = (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div>您的密码已过期，请前往影禾云平台修改</div>
                <a href={appConfig.url} target="_blank" rel="noreferrer">
                  立刻前往
                </a>
              </div>
            );
            UINotificationService.show({
              title: '系统提示',
              message: msg,
              type: 'error',
              autoClose: false,
            });
          }
        } else {
          UINotificationService.show({
            title: '登录失败',
            message: res.tip,
            type: 'error',
            autoClose: false,
          });
        }
      });
    } else {
      return;
    }
  };

  const clickVerCode = e => {
    setIsGetVerCode(isGetVerCode + 1);
  };

  return (
    <>
      <div
        style={{
          height: '100%',
          width: '100%',
          backgroundImage: `url('https://yinghe-pacs.oss-cn-hangzhou.aliyuncs.com/viewer/viewer.png') `,
          backgroundSize: '100% 100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            color: '#fff',
            paddingLeft: '64%',
            height: '100%',
          }}
        >
          <div className="ic_login__form">
            <div className="ic_login_title">登录</div>
            <form onSubmit={handleSubmit} className="form">
              <div className="form-item">
                <label className="form-item-label">手&ensp;&ensp;机</label>
                <input
                  placeholder="请输入手机号"
                  className={classNames('input', {
                    'is-invalid': errors.phone,
                  })}
                  type="text"
                  value={phone}
                  onChange={e => handleValueChange('phone', e.target.value)}
                />
                {errors.phone && <div className="error">{errors.phone}</div>}
              </div>
              <div className="form-item">
                <label className="form-item-label">密&ensp;&ensp;码</label>

                <input
                  placeholder="请输入密码"
                  className={classNames('input', {
                    'is-invalid': errors.password,
                  })}
                  type="password"
                  value={password}
                  onChange={e => handleValueChange('password', e.target.value)}
                />
                {errors.password && (
                  <div className="error">{errors.password}</div>
                )}
              </div>
              <div className="form-item">
                <label className="form-item-label">验证码</label>

                <div className="code">
                  <div className="code_input">
                    <input
                      placeholder="请输入验证码,点击图片可更换"
                      className={classNames('input', {
                        'is-invalid': errors.code,
                      })}
                      style={{ width: '190px' }}
                      type="text"
                      value={code}
                      onChange={e => handleValueChange('code', e.target.value)}
                    />
                  </div>
                  <div className="code_btn" onClick={clickVerCode}>
                    <img className="code_img" width="100px" src={verCode} />
                  </div>
                </div>
                {errors.code && <div className="error">{errors.code}</div>}
              </div>

              <input type="submit" className="submit" value="登录" />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

LoginRoute.propTypes = {
  filters: PropTypes.object,
  PatientID: PropTypes.string,
  server: PropTypes.object,
  user: PropTypes.object,
  history: PropTypes.object,
  studyListFunctionsEnabled: PropTypes.bool,
};

LoginRoute.defaultProps = {
  studyListFunctionsEnabled: true,
};

export default withRouter(LoginRoute);
